module.exports = __webpack_public_path__ + "static/assets/8465ca0e1c49f1757b0594b38861384d.svg";